import ls from '../ls';
import { getCustGoodsFields, getCustFunConfig, getStoreConfig as getStoreConfigApi, getSystemTranslateApi } from '@/api/common';
import { getTranslateConfig } from '@/api/hiddenGoodsTranslate';
import { changeMessageCust, mergeSystemLanguage } from "@/i18n/index";
import router from '@/router';

const hasLanguages = window.languages;
let navigatorLanguage = navigator.language || navigator.browserLanguage;
if (!hasLanguages[navigatorLanguage]) {
    navigatorLanguage = 'en';
}
const state = {
    language: window.localStorage.getItem('localeLanguage') ? window.localStorage.getItem('localeLanguage') : navigatorLanguage,
    // size: ls.getItem('size') || 'medium',
    sidebar: {
        opened: ls.getItem('sidebarStatus') !== null ? !!+ls.getItem('sidebarStatus') : true,
        withoutAnimation: false
    },
    unfoldSearch: 0,

    showRealm: '',
    currentCustomerCode: ls.getItem('currentCustomerCode') || '',
    currentStoreCode: ls.getItem('currentStoreCode') || '',
    customersOption: [],
    storesOption: [],

    goodsFields: [],
    custLanguage: {},
    custFunConfig: {},
    licenseInfo: {
        primaryLicenseId: '',
        enlargeLicenseIds: '',
        status: '',
        type: 0,
        limitedDate: true,
        needUpload: true,
        maturityDate: '',
        storeNum: 1,
        epdNum: 10,
    },

    storeConfig: {},
    storeInfo: {},

    menuWidth: ls.getItem('menuWidth') || 230,
    showMenu: ls.getItem('showMenu') ?? true,

    showDefaultSearch: true,
    pluginsConfig: [],
    viewLoading: false,
    systemTranslate: {},
    transTemporary: {},
};

const mutations = {
    SET_LANGUAGE: (state, language) => {
        state.language = language;
        window.localStorage.setItem('localeLanguage', language);
    },
    TOGGLE_SIDEBAR: state => {
        state.sidebar.opened = !state.sidebar.opened;
        state.sidebar.withoutAnimation = false;
        if (state.sidebar.opened) {
            ls.setItem('sidebarStatus', 1);
        } else {
            ls.setItem('sidebarStatus', 0);
        }
    },
    TOGGLE_SEARCH: state => {
        state.unfoldSearch = !state.unfoldSearch;
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
        ls.setItem('sidebarStatus', 0);
        state.sidebar.opened = false;
        state.sidebar.withoutAnimation = withoutAnimation;
    },
    OPEN_SIDEBAR: (state, withoutAnimation) => {
        ls.setItem('sidebarStatus', 1);
        state.sidebar.opened = true;
        state.sidebar.withoutAnimation = withoutAnimation;
    },
    SET_SIZE: (state, size) => {
        state.size = size;
        ls.setItem('size', size);
    },
    SET_SHOW_REALM: (state, realm) => {
        state.showRealm = realm;
    },
    SET_CURRENTCUSTOMER: (state, code) => {
        state.currentCustomerCode = code;
        ls.setItem('currentCustomerCode', code);
    },
    SET_MENUWIDTH: (state, width) => {
        state.menuWidth = width;
        ls.setItem('menuWidth', width);
    },
    SET_SHOWMENU: (state, status) => {
        state.showMenu = status;
        ls.setItem('showMenu', status);
    },
    SET_CUSTOMER_OPTION: (state, option) => {

        state.customersOption = option;
    },
    SET_CURRENTSTORE: (state, code) => {
        state.currentStoreCode = code;
        ls.setItem('currentStoreCode', code);
    },
    SET_STORE_OPTION: (state, option) => {
        let sortOption = [...option];
        sortOption.sort((a, b) => {
            return a.storeCode > b.storeCode ? 1 : -1;
        });
        state.storesOption = sortOption.filter(store => store.status == 'NORMAL');
    },
    SET_GOODS_FIELDS: (state, option) => {
        state.goodsFields = option || [];
    },

    SET_CUST_LANGUAGE: (state, obj) => {
        state.custLanguage = obj || {};
    },

    SET_SYSTEM_TRANSLATE: (state, obj) => {
        state.systemTranslate = obj || {};
    },

    SET_CUST_FUN_CONFIG: (state, obj) => {
        state.custFunConfig = obj || {};
    },

    SET_LICENSE_INFO: (state, obj) => {
        state.licenseInfo = Object.assign({
            primaryLicenseId: '',
            enlargeLicenseIds: '',
            status: '',
            type: 0,
            source: '',
            limitedDate: true,
            needUpload: true,
            maturityDate: '',
            ewNum: 1,
            storeNum: 1,
            epdNum: 10,
        }, obj);
    },

    SET_SEARCHTYPE: (state, type = true) => {
        state.showDefaultSearch = type;
    },

    SET_PLUGINS_CONFIG: (state, config = []) => {
        state.pluginsConfig = config;
    },

    SET_STORE_CONFIG: (state, config = {}) => {
        state.storeConfig = config;
    },

    SET_STORE_INFO: (state, info = {}) => {
        state.storeInfo = info;
    },

    SET_VIEW_LOADING: (state, loading = false) => {
        state.viewLoading = loading;
    },

    SET_TRANS_STORAGE: (state, transCon) => {
        state.transTemporary = transCon;
    },
};

const actions = {
    setLanguage({ commit }, language) {
        commit('SET_LANGUAGE', language);
    },
    toggleSideBar({ commit }) {
        commit('TOGGLE_SIDEBAR');
    },
    changeMenuWidth({ commit, rootState }, width) {
        commit('SET_MENUWIDTH', width);
        if (window.__POWERED_BY_QIANKUN__) {
            rootState.global.props.setGlobalState({ menuWidth: width });
        }
    },
    changeShowMenu({ commit, rootState }, status) {
        commit('SET_SHOWMENU', status);
        if (window.__POWERED_BY_QIANKUN__) {
            rootState.global.props.setGlobalState({ showMenu: status });
        }
    },
    toggleSearch({ commit }) {
        commit('TOGGLE_SEARCH');
    },
    setSize({ commit }, size) {
        commit('SET_SIZE', size);
    },
    setShowRealm({ commit }, realm) {
        commit('SET_SHOW_REALM', realm);
    },
    async setCurrentCustomer({ commit, dispatch, rootState }, params) {
        let code = typeof params != 'string' ? params.code : params;
        let dispatchGlobal = typeof params != 'string' ? params.dispatchGlobal : true;
        commit('SET_CURRENTCUSTOMER', code);

        let customer = state.customersOption.find(item => item.customerCode == code);
        let stores = {};
        if (customer) {
            stores = customer.stores || {};
            commit('SET_STORE_OPTION', Object.values(stores));
            commit('SET_SHOW_REALM', rootState.user.realm == 'ADMIN' ? 'ADMIN' : 'SYSTEM');
            await dispatch('getGoodsFields');
            await dispatch('getFunConfig');
            dispatch('getCustLanguage');
            if (window.__POWERED_BY_QIANKUN__ && dispatchGlobal) {
                rootState.global.props.setGlobalState({ currentCustomer: customer.customerCode });
            }
            commit('SET_CURRENTSTORE', '');
            dispatch('getStoreConfig');
        } else {
            commit('SET_CURRENTSTORE', '');
            commit('SET_STORE_OPTION', Object.values(stores));
            dispatch('getStoreConfig');
            if (!code) {
                changeMessageCust();
                commit('SET_SHOW_REALM', 'GLOBAL');
            } else {
                commit('SET_SHOW_REALM', rootState.user.realm == 'ADMIN' ? 'ADMIN' : 'SYSTEM');
            }
        }
    },
    async setCurrentStore({ commit, dispatch, rootState }, params) {
        let code = typeof params != 'string' ? params.code : params;
        let dispatchGlobal = typeof params != 'string' ? params.dispatchGlobal : true;
        commit('SET_CURRENTSTORE', code);
        if (code) {
            commit('SET_SHOW_REALM', 'NORMAL');
        } else {
            commit('SET_SHOW_REALM', rootState.user.realm == 'ADMIN' ? 'ADMIN' : 'SYSTEM');
        }
        await dispatch('getStoreConfig');
        if (window.__POWERED_BY_QIANKUN__ && dispatchGlobal) {
            rootState.global.props.setGlobalState({ currentStore: code });
        }
    },

    getStoreConfig({ commit, state }) {
        return new Promise(resolve => {
            if (state.currentStoreCode) {
                getStoreConfigApi({ language: state.language }, state.currentCustomerCode, state.currentStoreCode)
                    .then(res => {
                        if (res.resultCode == 1001) {
                            commit('SET_STORE_CONFIG', res.data.config || {});
                            commit('SET_STORE_INFO', res.data.storeInfo || {});
                        } else {
                            commit('SET_STORE_CONFIG', {});
                            commit('SET_STORE_INFO', {});
                        }
                    }).finally(() => {
                        resolve();
                    });
            } else {
                commit('SET_STORE_CONFIG', {});
                resolve();
            }
        });
    },

    routerName(state, args = {}) {
        const { name = '' } = args;
        if (name == 'dashboardPage' || !name) {
            router.push({ name: 'toredirect', params: { name: 'dashboardPage' } });
        } else {
            router.push(...args);
        }
    },

    async updateCustomerOption({ commit, dispatch, state }, customers = {}) {
        let customerList;
        customerList = Object.values(customers).map(item => {
            return {
                customerCode: item.customerCode,
                customerName: item.customerName,
                stores: item.stores || {}
            };
        });
        commit('SET_CUSTOMER_OPTION', customerList);
        if (state.currentCustomerCode) {
            let stores = customerList.find(item => item.customerCode == state.currentCustomerCode).stores;
            commit('SET_STORE_OPTION', Object.values(stores));
            const storeCode = state.currentStoreCode;
            await dispatch('setCurrentCustomer', state.currentCustomerCode);
            await dispatch('setCurrentStore', storeCode);

        }
    },

    getSystemTranslate({ commit }) {
        return new Promise(reslove => {
            let lang = window.HS_CONST_VAL.languageArr || [];
            getSystemTranslateApi({
                language: lang.map(item => item.value)
            }).then(res => {
                if (res.resultCode == 1001) {
                    mergeSystemLanguage(res.data);
                    commit('SET_SYSTEM_TRANSLATE', res.data);
                }
            });
            reslove();
        });
    },


    async loadShow({ commit, dispatch, state }, { userInfo, customers = {} }) {
        // return new Promise(resolve => {
        await dispatch('updateCustomerOption', customers);
        if (!state.currentCustomerCode) {
            if (userInfo.realm == 'GLOBAL') {
                commit('SET_SHOW_REALM', 'GLOBAL');
            } else if (userInfo.realm == 'SYSTEM' || userInfo.realm == 'ADMIN') {
                commit('SET_SHOW_REALM', userInfo.realm == 'ADMIN' ? 'ADMIN' : 'SYSTEM');
                await dispatch('setCurrentCustomer', userInfo.customerCode);
            } else {
                let customer = state.customersOption.find(item => item.customerCode == userInfo.customerCode);
                let stores = customer.stores || {};
                let storeList = Object.values(stores);
                let choseFirstStore = storeList.length ? storeList[0].storeCode || '' : '';
                await dispatch('setCurrentCustomer', userInfo.customerCode);
                await dispatch('setCurrentStore', choseFirstStore);
                commit('SET_SHOW_REALM', 'NORMAL');

            }
        }
    },

    async quankunloadshow({ commit, dispatch, state, rootState }, { customers = {} }) {
        let customerList;
        customerList = Object.values(customers).map(item => {
            return {
                customerCode: item.customerCode,
                customerName: item.customerName,
                stores: item.stores || {}
            };
        });
        commit('SET_CUSTOMER_OPTION', customerList);
        if (state.currentCustomerCode) {
            if (state.currentCustomerCode != undefined && state.currentCustomerCode != '') {
                let stores = customerList.find(item => item.customerCode == state.currentCustomerCode).stores;
                commit('SET_STORE_OPTION', Object.values(stores));
                if (!rootState.global.props.getGlobalState('servicePage')) {
                    return;
                }
                await dispatch('getGoodsFields');
                await dispatch('getFunConfig');
                dispatch('getCustLanguage');
                dispatch('getStoreConfig');
            }
        }

    },

    getGoodsFields({ commit, state }) {
        return new Promise(resolve => {
            if (state.currentCustomerCode) {
                getCustGoodsFields({}, state.currentCustomerCode)
                    .then(res => {
                        if (res.resultCode == 1001) {
                            commit('SET_GOODS_FIELDS', res.data);
                        }
                    }).finally(() => {
                        resolve();
                    });
            } else {
                resolve();
            }
        });
    },

    getCustLanguage({ commit, state }, module = '') {
        if (state.currentCustomerCode) {
            getTranslateConfig({
                language: state.language,
                module: module
            }, state.currentCustomerCode)
                .then(res => {
                    if (res.resultCode == 1001) {
                        const custObj = res.data || {};
                        commit('SET_CUST_LANGUAGE', { [state.language]: custObj });
                    } else {
                        commit('SET_CUST_LANGUAGE', {});
                    }
                }).finally(() => {
                    changeMessageCust(state.currentCustomerCode);
                });
        } else {
            commit('SET_CUST_LANGUAGE', {});
            changeMessageCust(state.currentCustomerCode);
        }
    },

    getFunConfig({ commit, state }) {
        return new Promise(resolve => {
            if (state.currentCustomerCode) {
                getCustFunConfig({}, state.currentCustomerCode)
                    .then(res => {
                        if (res.resultCode == 1001) {
                            const custObj = res.data || {};
                            commit('SET_CUST_FUN_CONFIG', custObj);
                        }
                    }).finally(() => {
                        resolve();
                    });
            } else {
                // commit('SET_CUST_LANGUAGE', {});
                resolve();
            }
        });
    },

    temporaryStorageTrans({ commit, state }, changeCon) {
        //TODO 待修改，需要考虑切换语言，已语言为单位
        let tranCon = Object.assign({}, state.temporaryStorageTrans, changeCon);
        commit('SET_TRANS_STORAGE', tranCon);
    },

    celarTransTemporary({ commit }) {
        commit('SET_TRANS_STORAGE', {});
    }

};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};